import React from "react";
import styled, { css } from "styled-components";
import { lighten, transparentize } from "polished";
import { useLocation } from "react-router-dom";
import { experienceEasterPath } from "../../../paths";
import routing from "../../../routing";
import Icon from "../../../icon";
import { isMobile } from "../../../../common/parameters";

interface IStyleProps {
    isLow?: boolean,
    handleLeftBottom?: boolean,
    isEaster?: boolean,
};

export const SubmitButton = styled.button<IStyleProps>`
    padding: 10px;
    display: inline-block;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
    position: absolute;
    bottom: -6px;
    left: 540px;
    width: 200px;
    text-align: center;
    font-size: 30px;
    border-radius: 50px;
    border-color: black !important;
    background-color: ${p => p.theme.c.correct};
    outline: none;

    &:hover {
        background-color: ${p => lighten(0.05, p.theme.c.correct)};
    }

    &:disabled {
        background-color: ${p => transparentize(1 - 0.6, p.theme.c.correct)};
        &:hover {
            background-color: ${p => transparentize(1 - 0.6, p.theme.c.correct)};
        }
    }

    ${p =>
        p.isLow
            ? css`
                  padding: 8px 18px !important;
              `
            : undefined}
    
    ${p => p.isEaster && css`
        background-image: url("${experienceEasterPath}/submit-button.svg");
        background-color: transparent;
        background-size: 100% 100%;
        border: none;
        padding-bottom: 13px !important;
        padding-top: 19px !important;
        padding-left: 12px;
        padding-right: 51px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 23px;
        margin-top: -1px;
        border-radius: 0;
        &:hover {
            background-color: transparent;
            opacity: 0.8;
        }
        transition: 100ms;
        &:focus {
            border: none;
        }

        &:active {
            transform: translate(2px, 2px);
        }
    `}
`;

export const StyledPlayBtn = styled.button<IStyleProps>`
    position: absolute;
    top: 5px;
    left: 5px;
    font-size: 30px;
    font-weight: 400;
    z-index: 3;
    display: inline-block;
    vertical-align: top;
    transition: background-color 0.3s;
    border-radius: 50px;
    border-color: black !important;
    padding: 8px 18px 4px !important;
    white-space: nowrap;
    color: ${p => p.theme.c.whiteOnActive};
    :disabled {
        color: ${p => p.theme.c.whiteOnActive} !important;
    }
    svg,
    [class^="i-"] {
        font-size: 30px;
        display: inline-block;
        color: ${p => p.theme.c.whiteOnActive};
        fill: ${p => p.theme.c.whiteOnActive};
    }

    .i-pause {
        transform: scale(1.4, 1.1) translateX(-2px);
    }

    ${p =>
        p.isLow
            ? css`
                  left: 32px;
                  top: 32px;
              `
            : undefined}
    
    ${p => p.isEaster && css`
        background-image: url("${experienceEasterPath}/play-button.svg");
        background-color: transparent !important;
        background-size: 100% 100%;
        border: none !important;
        padding-bottom: 10px !important;
        padding-top: 13px !important;
        padding-left: 20px !important;
        padding-right: 22px !important;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 23px;
        margin-top: -1px;
        border-radius: 0;
        &:hover {
            background-color: transparent;
            opacity: 0.8;
        }
        transition: 100ms;
        &:focus {
            border: none;
        }

        &:active {
            transform: translate(2px, 2px);
        }
    `}
`;

export const StyledResetButton = styled.div`
    display: inline-block;
    span[class^="i-"] {
        font-size: 42px;
        margin: -9px -8px -18px 4px;
        transform: translateY(5px);
    }
`;


export const PlayBtn = (props: any) => {
    const location = useLocation();
    const isExperience = !props.notExperienceTask && location.pathname.indexOf(routing.experience) !== -1 || (process.env.WEBPACK && window.homeworkAsExperience);
    return (
        <StyledPlayBtn {...props} style={{ ...props.style, marginLeft: isExperience ? 60 : 0, marginRight: isExperience ? 60 : 0 }}>
            {props.children}
            {props.resetPlay && (
                <StyledResetButton
                    onClick={(e) => {
                        if (isMobile) return;
                        props.resetPlay(e);
                    }}
                    onTouchStart={(e) => {
                        if (!isMobile) return;
                        props.resetPlay(e);
                    }}
                >
                    <Icon i="refresh" />
                </StyledResetButton>
            )}
        </StyledPlayBtn>
    )
}


const StyledCheckPlayBtn = styled(StyledPlayBtn)<IStyleProps>`
    right: 5px;
    left: auto !important;
    ${p =>
        p.isLow
            ? css`
                  right: 32px;
              `
            : undefined}
    ${p => p.isEaster && css`
        background-image: url("${experienceEasterPath}/check-button.svg");
    `}
`;

export const CheckPlayBtn = (props: any) => {
    return (
        <StyledCheckPlayBtn {...props}>
            {props.children}
            {props.resetPlay && (
                <StyledResetButton onClick={props.resetPlay}><Icon i="refresh" /></StyledResetButton>
            )}
        </StyledCheckPlayBtn>
    );
};

export const DeleteButton = styled(StyledPlayBtn)<IStyleProps>`
    right: 5px;
    left: auto;
    ${p =>
        p.isLow
            ? css`
                  right: 32px;
              `
            : undefined}
    ${p => p.isEaster && css`
        background-image: url("${experienceEasterPath}/delete-button.svg");
    `}
`;

export const Label = styled.div`
    display: inline-block;
    vertical-align: top;
    line-height: 34px;
    margin-left: 6px;
    margin-bottom: 0px;
    svg {
        fill: ${p => p.theme.c.info};
        width: 20px;
        height: 20px;
        margin-left: 5px;
    }
`;

export const TopRight = styled.div<IStyleProps>`
    position: absolute;
    top: ${p => (p.handleLeftBottom ? "auto" : `${p.isLow ? 30 : 5}px`)};
    right: ${p => (p.handleLeftBottom ? "auto" : `${p.isLow ? 30 : 5}px`)};
    bottom: ${p => (p.handleLeftBottom ? `${p.isLow ? 30 : 5}px` : "auto")};
    left: ${p => (p.handleLeftBottom ? `${p.isLow ? 30 : 5}px` : "auto")};
    display: flex;
    z-index: 1;
    flex-direction: ${p => (p.handleLeftBottom ? "row-reverse" : "row")};

    .button {
        position: static;
        margin-left: ${p => (p.handleLeftBottom ? 0 : 8)}px;
        margin-right: ${p => (p.handleLeftBottom ? 8 : 0)}px;
        margin-bottom: 0;
    }
`;

export const SelectWrapper = styled.div`
    margin: 4px;
    display: flex;
    align-items: center;
    > div {
        margin-bottom: 0;
    }
`;
